import { useCallback } from 'react';

import { useControlStore } from 'store/controls';
import { useTimerStore } from 'store/timer';

import { EPaths } from 'router/const/paths';

import { useDisableManageMicrophoneLevelAndLeave } from './useDisableManageMicrophoneLevelAndLeave';

/** Хук вернет функцию для выхода из конференции */
export function useLeaveConference() {
    const { setAvailableTime } = useTimerStore();
    const { setControls } = useControlStore();
    const disableManageMicrophoneLevelAndLeave = useDisableManageMicrophoneLevelAndLeave(EPaths.EXIT);

    return useCallback(() => {
        setAvailableTime(null);
        setControls(controls => ({ ...controls, leave: false }));
        disableManageMicrophoneLevelAndLeave();
    }, [disableManageMicrophoneLevelAndLeave]);
}
